














































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import VueMonthlyPicker from 'vue-monthly-picker';
import SearchIcon from 'mdi-vue/Magnify';
import FormInput from '@/components/FormInput.vue';
import ExportIcon from 'mdi-vue/FileExportOutline';
import { mapState } from 'vuex';
import api from '@/libs/api';
import { User } from '@/libs/api.interfaces';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Modal from '@/components/Modal.vue';
import TagInput from '@/components/TagInput.vue';
import Toggle from '@/components/Toggle.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import DatePicker, { DateRange } from '@/components/DatePicker.vue';
import ReportTable from './OnepayMerchantTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    TagInput,
    Toggle,
    Modal,
    Table,
    Row,
    FormInput,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    VueMonthlyPicker,
    Tab,
    SearchIcon,
    ExportIcon,
    DatePicker,
    SearchField,
    SearchRow,
    Select,
    ReportTable,
  },
  computed: mapState(['user']),
})
export default class OnepayMerchant extends Vue {
  user!: {
    user: User;
  };

  merchantLoginData: any = this.$store.state.user.user;
  userRole: any = this.merchantLoginData.user_role.role;
  showModalVa = false;
  summaryparameter = {};
  merchantnamefilter: any = '';

  currentChannel = {
    title: 'Credit Card',
    code: 'creditcard',
    path: 'creditcard',
  }

  searchOpen = false;
  showItemprpage = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
  ];

  transactionDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  selectedMerchants: any = []
  tagIds: SelectItem[] = []
  channelIds: string[] = []
  loadingMerchant = false;
  loadingExport = false;

  channelIdList: string[] = [];
  loadingChannelId = false;

  generalSearch = '';
  startperiode = '';
  endperiode = '';
  locale = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  merchants = [
    {
      /* eslint-disable @typescript-eslint/camelcase */
      merchant_code: '',
      merchant_name: 'Enter merchant name',
      $isDisabled: true,
      /* eslint-enable @typescript-eslint/camelcase */
    },
  ];

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  $refs!: {
    report: ReportTable;
  }

  format!: (val: string) => string;

  mounted() {
    // this.getListData(1);
    this.parseParams();
    // this.getChannelIds();
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  openModal() {
    this.showModalVa = true;
    console.log('changed');
  }

  closeModal() {
    this.showModalVa = false;
  }

  async getListData(page: number) {
    /* eslint-disable @typescript-eslint/camelcase */
    // if (page === 1 && this.$route.query.page) {
    //   const query = { ...this.$route.query };
    //   delete query.page;
    //   this.$router.replace({ query });
    // }

    if (this.userRole === 'Super Admin') {
      this.summaryparameter = {
        user_group: 'SPRINT',
        user_role: 'ADMIN',
        merchant_name: this.merchantnamefilter,
        sort: 'desc',
      };
    } else {
      this.summaryparameter = {
        user_role: 'MANAGER',
        user_group: 'MERCHANT',
        merch_id: this.merchantLoginData.merchant_id,
        merchant_name: this.merchantnamefilter,
        sort: 'desc',
      };
    }
    const params = this.summaryparameter;
    // console.log(params);
    await this.$refs.report.getListData(params, page);
  }

  async getMerchants(query: string) {
    if (query === '') return;

    try {
      this.loadingMerchant = true;
      const { data } = await api.get('/onepay/merchants_sipg', {
        params: {
          user_role: this.userRole === 'Super Admin' ? 'ADMIN' : 'MANAGER',
          merchant_name: query,
        },
      });
      this.merchants = data;
      console.log('getmerchant', this.merchants);
      this.loadingMerchant = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getTransaction(isExport = false, page: number) {
    const params = {
      channel: this.currentChannel,
      channelIds: this.channelIds,
    };

    if (isExport) {
      await this.$refs.report.export(params);
    } else {
      await this.$refs.report.getTransaction(params, false, page);
    }
  }

  parseParams() {
    this.showModalVa = false;
    const params = this.$route.query;

    if (typeof params.mc === 'string') {
      const merchants = JSON.parse(params.mc).map((e: { c: string; n: string }) => ({
        /* eslint-disable @typescript-eslint/camelcase */
        merchant_code: e.c,
        merchant_name: e.n,
        /* eslint-enable @typescript-eslint/camelcase */
      }));
      this.selectedMerchants = merchants;
    } else {
      this.selectedMerchants = [];
    }

    if (typeof params.ch === 'string') {
      const channelIds = params.ch.split(',');
      this.channelIds = channelIds;
    } else {
      this.channelIds = [];
    }

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getListData(page);
  }

  async addMer() {
    /* eslint-disable @typescript-eslint/camelcase */
    console.log('data', this.merchantLoginData);
    console.log('selectedmerchant', this.selectedMerchants);
    console.log('detailselectedmerchant', this.selectedMerchants.id);
    try {
      if (this.userRole === 'Super Admin') {
        await api.post('/onepay/merchants_add', {
          user_role: 'ADMIN',
          user_group: 'SPRINT',
          mid: this.selectedMerchants.m_id,
          merhcant_code: this.selectedMerchants.merchant_code,
          merchant_name: this.selectedMerchants.merch_name,
          single_integration_secret_key: this.selectedMerchants.secret_key,
          payment_url: this.selectedMerchants.web_url,
          refund_receiver: this.selectedMerchants.receiver_cust_residence,
          use_onepay_trx: '',
          is_active: 'on',
        });
      } else {
        await api.post('/onepay/merchants_add', {
          user_role: 'MANAGER',
          user_group: 'MERCHANT',
          mid: this.selectedMerchants.m_id,
          merhcant_code: this.selectedMerchants.merchant_code,
          merchant_name: this.selectedMerchants.merch_name,
          single_integration_secret_key: this.selectedMerchants.secret_key,
          payment_url: this.selectedMerchants.web_url,
          refund_receiver: this.selectedMerchants.receiver_cust_residence,
          use_onepay_trx: '',
          is_active: 'on',
        });
      }
      this.closeModal();
    } catch (err) {
      console.error(err);
    }
  }

  async exportData() {
    this.loadingExport = true;
    await this.getTransaction(true, 1);
    this.loadingExport = false;
  }

  findmerchant() {
    this.merchantnamefilter = this.generalSearch;
  }

  search() {
    this.getListData(1);
  }

  cancel() {
    this.transactionDate = {
      startDate: null,
      endDate: null,
    };
    this.selectedMerchants = [];
    this.tagIds = [];
    this.channelIds = [];

    this.$router.push({
      query: {},
    });
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }
}
